/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.57"
        height="88.62"
        viewBox="0 0 95.57 88.62"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M7.62 52.59a1.25 1.25 0 0 1 1.53.89 40.23 40.23 0 0 0 18 23.91 1.252 1.252 0 0 1-1.3 2.14A42.73 42.73 0 0 1 6.73 54.12a1.26 1.26 0 0 1 .89-1.53ZM86.17 53.81a1.25 1.25 0 0 1 2.41.66 42.2 42.2 0 0 1-19.21 25.24 1.251 1.251 0 1 1-1.28-2.15 39.68 39.68 0 0 0 18.08-23.75ZM47.7 0a42.12 42.12 0 0 1 24.28 7.63 1.25 1.25 0 0 1-1.44 2 39.88 39.88 0 0 0-45.65 0 1.23 1.23 0 0 1-1.66-.6 1.25 1.25 0 0 1 .23-1.4A42.12 42.12 0 0 1 47.7 0Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M13.98 16.42a7.85 7.85 0 1 0 7.84 7.86 7.84 7.84 0 0 0-7.84-7.86Zm0 2.5a5.35 5.35 0 1 1-5.35 5.35 5.34 5.34 0 0 1 5.34-5.34ZM20.42 35.14a7.51 7.51 0 0 1 7.5 7.25v1.18a1.25 1.25 0 0 1-2.49.12v-1a5 5 0 0 0-4.78-5H7.49a5 5 0 0 0-5 4.78v1.15a1.25 1.25 0 0 1-2.49.12v-1a7.51 7.51 0 0 1 7.25-7.5h13.17ZM81.61 16.42a7.85 7.85 0 1 0 7.88 7.84 7.85 7.85 0 0 0-7.88-7.84Zm0 2.5a5.35 5.35 0 1 1-5.34 5.36 5.34 5.34 0 0 1 5.34-5.36ZM88.08 35.14a7.5 7.5 0 0 1 7.49 7.25v1.18a1.23 1.23 0 0 1-1.23 1.25 1.26 1.26 0 0 1-1.24-1.13v-1a5 5 0 0 0-4.78-5H75.14a5 5 0 0 0-5 4.78v1.15a1.23 1.23 0 0 1-1.23 1.25 1.26 1.26 0 0 1-1.24-1.13v-1a7.51 7.51 0 0 1 7.26-7.5h13.18ZM47.59 60.2a7.85 7.85 0 1 0 7.84 7.86V68a7.86 7.86 0 0 0-7.84-7.8Zm0 2.5a5.35 5.35 0 1 1-5.35 5.35V68a5.34 5.34 0 0 1 5.35-5.3ZM54.06 78.92a7.5 7.5 0 0 1 7.49 7.25v1.18a1.25 1.25 0 0 1-2.49.12v-1a5 5 0 0 0-4.78-5H41.12a5 5 0 0 0-5 4.78v1.15a1.25 1.25 0 0 1-2.49.12v-1a7.51 7.51 0 0 1 7.26-7.5h13.17Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'ThreePeopleConnectedByOuterLinesIcon';

export default Icon;
